// This file was generated by "make codegen/icons". DO NOT EDIT.
import { createSvgIcon } from "@mui/material";
/* GENERATED */
const SpeechBubbleIcon = createSvgIcon(
  <svg width={24} height={24} fill="none" viewBox="0 0 24 24">
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={1.5}
      d="M6.39 16.99a8.2 8.2 0 1 1 3.3 1.89h0l-3.56 2.35z"
      clipRule="evenodd"
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={1.5}
      d="M12 7.04v5.24M12 14.83v.27"
    />
  </svg>,
  "SpeechBubble",
);
export default SpeechBubbleIcon;
